export const useAvatarGroupPopoverContextValues = (state)=>{
    const avatarGroup = {
        isOverflow: true,
        size: 24
    };
    return {
        avatarGroup
    };
};
